<template>
  <v-container fluid>
    <v-row align="center" justify="space-between" class="dddark rounded mb-5 infocontainer" style="margin-top: -10px;" v-show="noDataAvailable">
      <v-col cols="12">
        <span class="d-block pb-1 text-h6 text-center">{{$t('components.WebMDDashboard.NoData')}}</span>
      </v-col>
    </v-row>

    <v-row align="start" justify="space-between" class="dddark rounded" style="margin-top: -10px;">
      <v-col cols="auto">
        <span class="d-block pb-1 text-h6">{{$t('components.WebMDDashboard.Title')}} {{ this.clinic }}</span>
      </v-col>
      <v-col cols="auto" v-if="!isMobile">
        <v-btn
            outlined
            elevation="0"
            @click="downloadReport"
            :disabled="loading"
            style="margin-top: 1px; border-color: var(--v-ddgrey-base )">
          <v-icon color="ddgrey">mdi-download</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row id="webmd_report" class="ddblack">
      <v-col cols="12" md="6">
        <VisibilityMetricsPercentages :statistics="data.percentages.visibility" :total-records="data.totalRecords.visibility" :loading="loading"/>
      </v-col>

      <v-col cols="12" md="6">
        <ContactMetricsPercentages :statistics="data.percentages.contact" :total-records="data.totalRecords.contact" :loading="loading"/>
      </v-col>

      <v-col cols="12">
        <VisibilityMetricsChart :chartData="data.chartData.visibility" :loading="loading"/>
      </v-col>

      <v-col cols="12">
        <ContactMetricsChart :chartData="data.chartData.contact" :loading="loading"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import DataAPI from '@/utils/DataAPI';
import EventBus from '@/utils/EventBus';

import VisibilityMetricsChart from "@/components/dashboard/webmd/VisibilityMetricsChart.vue";
import VisibilityMetricsPercentages from "@/components/dashboard/webmd/VisibilityMetricsPercentages.vue";
import ContactMetricsChart from "@/components/dashboard/webmd/ContactMetricsChart.vue";
import ContactMetricsPercentages from "@/components/dashboard/webmd/ContactMetricsPercentages.vue";

/**
 * This component includes all the metrics and charts of WebMD Dashboard page */

export default {
  name: 'WebMDDashboard',
  props: {
    initialClinic: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    loading: true,
    clinic: "",
    noDataAvailable: false,
    data: {
      statistics: {
        visibility_statistics: {
          by_month: {},
          by_month_accumulative: {},
          by_day_of_week: {},
          by_type: {}
        },
        contact_statistics: {
          by_month: {},
          by_month_accumulative: {},
          by_day_of_week: {},
          by_type: {}
        }
      },
      percentages: {
        visibility: {},
        contact: {}
      },
      totalRecords: {
        visibility: null,
        contact: null
      },
      chartData: {
        visibility: {},
        contact: {}
      },
    },
    dateFilter: {
      from: false,
      to: false
    },
    isMobile: false
  }),
  async mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
    await this.updateData(this.initialClinic);
  },
  methods: {
    async updateData(clinic = false, location = false) {
      console.log("Update WebMD data");
      if (clinic && window.GA) {
        window.GA.trackEvent('webmd_selection_changed', clinic);
      }
      this.loading = true;
      const { from, to } = this.dateFilter;

      this.data = await DataAPI.getWebMDStats({ clinic, location, from, to });
      this.clinic = clinic;

      if (this.statisticsAreEmpty()) {
        this.noDataAvailable = true;
      }
      this.loading = false;
    },
    statisticsAreEmpty() {
      let totalCount = 0;
      for(const key in this.data.statistics.contact_statistics.by_type) {
        totalCount += this.data.statistics.contact_statistics.by_type[key];
      }
      for(const key in this.data.statistics.visibility_statistics.by_type) {
        totalCount += this.data.statistics.visibility_statistics.by_type[key];
      }
      return totalCount <= 0;
    },
    async downloadReport() {
      EventBus.$emit("popup", "Downloading...");
      const reportElement = document.getElementById('webmd_report');
      const filename = `${this.clinic}_webmd_stats.pdf`;
      const canvas = await html2canvas(reportElement);
      const img = canvas.toDataURL('image/png');
      const doc = new jsPDF({
        unit: 'px',
        format: [canvas.width, canvas.height],
        hotfixes: ["px_scaling"]
      });
      doc.addImage(img, 'PNG', 0, 0);
      doc.save(filename);
    },

    onResize() {
      this.isMobile = window.innerWidth < 1000;
    }
  },
  components: {
    VisibilityMetricsChart,
    VisibilityMetricsPercentages,
    ContactMetricsChart,
    ContactMetricsPercentages
  }
}
</script>
<style scoped>
.infocontainer {
  background-color: var(--v-ddlightblue-base) !important;
}
</style>
